const isitma = [
  {
    "title": "TommaTech 28-21kW Havuz Isı Pompaları(TriFaze-MonoFaze)",
    "image": "https://cw-enerji.com/images/kategory_grup/141_tommatech-28-21kw-havuz-isi-pompalaritrifaze-monofaze.webp",
    "text": "Çevre Dostu R32 Soğutucu Akışkan\nYüksek Verimlilik\nHızlı Isıtma\nAkıllı Su Sıcaklığı Ayarlama\nYumuşak Başlama(Soft Kalkış)\nSessiz Çalışma\nAkıllı Su Sıcaklığı Ayarlama",
    "variants": [
      {
        "wp": "28 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-28kw-havuz-isi-pompasitrifaze-1372.html"
      },
      {
        "wp": "21 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-21kw-havuz-isi-pompasimonofaze-1371.html"
      }
    ]
  },
  {
    "title": "TommaTech 26-16kW Titan Serisi Isı Pompaları(TriFaze)",
    "image": "https://cw-enerji.com/images/kategory_grup/143_tommatech-26-16kw-isi-pompalaritrifaze.webp",
    "text": "Çevre Dostu R32 Soğutucu Akışkan\nDaha Geniş Çalışma Aralığı\nFull DC İnverter Teknolojisi\nAkıllı Su Sıcaklığı Ayarlama\nYüksek Verimlilik\nWi-Fi Akıllı Kontrol\nDokunmatik 7 inç Ekran\nDüşük Ses Seviyesi",
    "variants": [
      {
        "wp": "26 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-26kw-titan-serisi-isi-pompasitrifaze-1377.html"
      },
      {
        "wp": "20 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-20kw-titan-serisi-isi-pompasitrifaze-1376.html"
      },
      {
        "wp": "16 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-16kw-titan-serisi-isi-pompasitrifaze-1375.html"
      }
    ]
  },
  {
    "title": "TommaTech 16-6kW Titan Serisi Isı Pompaları(MonoFaze)",
    "image": "https://cw-enerji.com/images/kategory_grup/142_tommatech-16-6kw-isi-pompalarimonofaze.webp",
    "text": "Çevre Dostu R32 Soğutucu Akışkan\nDaha Geniş Çalışma Aralığı\nFull DC İnverter Teknolojisi\nAkıllı Su Sıcaklığı Ayarlama\nYüksek Verimlilik\nWi-Fi Akıllı Kontrol\nDokunmatik 7 inç Ekran\nDüşük Ses Seviyesi",
    "variants": [
      {
        "wp": "16 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-16kw-titan-serisi-isi-pompasimonofaze-1374.html"
      },
      {
        "wp": "13 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-13kw-titan-serisi-isi-pompasimonofaze-1373.html"
      },
      {
        "wp": "9 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-9kw-titan-serisi-isi-pompasimonofaze-1426.html"
      },
      {
        "wp": "6 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-6kw-titan-serisi-isi-pompasimonofaze-1402.html"
      }
    ]
  },
  {
    "title": "TommaTech 24-8.3kW Power Serisi Isı Pompaları",
    "image": "https://cw-enerji.com/images/kategory_grup/206_tommatech-24-83kw-power-serisi-isi-pompalari.webp",
    "text": "Çevre Dostu R290 Soğutucu Akışkan\nDaha Geniş Çalışma Aralığı\nFull DC İnverter Teknolojisi\nAkıllı Su Sıcaklığı Ayarlama\nYüksek Verimlilik\nWi-Fi Akıllı Kontrol\nDokunmatik 5 inç Ekran",
    "variants": [
      {
        "wp": "24 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-24kw-r290-power-serisi-isi-pompasitrifaze-1841.html"
      },
      {
        "wp": "18.2 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-182kw-r290-power-serisi-isi-pompasitrifaze-1840.html"
      },
      {
        "wp": "14.8 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-148kw-r290-power-serisi-isi-pompasitrifaze-1839.html"
      },
      {
        "wp": "8.3 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-83kw-r290-power-serisi-isi-pompasimonofaze-1838.html"
      }
    ]
  },
  {
    "title": "TommaTech 23-8.4kW Power Serisi Isı Pompaları",
    "image": "https://cw-enerji.com/images/kategory_grup/207_tommatech-23-84kw-power-serisi-isi-pompalari.webp",
    "text": "Çevre Dostu R32 Soğutucu Akışkan\nDaha Geniş Çalışma Aralığı\nFull DC İnverter Teknolojisi\nAkıllı Su Sıcaklığı Ayarlama\nYüksek Verimlilik\nWi-Fi Akıllı Kontrol\nDokunmatik 5 inç Ekran",
    "variants": [
      {
        "wp": "23 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-23kw-r32-power-serisi-isi-pompasitrifaze-1845.html"
      },
      {
        "wp": "18.2 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-182kw-r32-power-serisi-isi-pompasitrifaze-1844.html"
      },
      {
        "wp": "13 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-13kw-r32-power-serisi-isi-pompasitrifaze-1843.html"
      },
      {
        "wp": "8.4 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-84kw-r32-power-serisi-isi-pompasimonofaze-1842.html"
      }
    ]
  }
];

export default isitma;
